import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
  * @module progress
  * @description A module to help with blocking user access by displaying a shield and text.<br>
  * It supports various styles of display.
  *
  * * Progress.startXxxxx starts up blocking display
  * * Progress.setXxxxx updates blocking display
  * * Progress.done closes blocking display
  */
import React from 'react';
import ReactDom from 'react-dom';
import ReactDomServer from 'react-dom/server';
import _ from 'lodash';
import { Shield, ModalDialog } from 'f2eUI'; // import { ModalDialog } from 'f2eUI/modal-dialog';

var globalProgress = null;
var INITIAL_STATE = {
  display: null,
  loaded: null,
  total: null,
  className: '',
  style: {}
};

var Progress = /*#__PURE__*/function (_React$Component) {
  _inherits(Progress, _React$Component);

  var _super = _createSuper(Progress);

  function Progress() {
    var _this;

    _classCallCheck(this, Progress);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "state", _.clone(INITIAL_STATE));

    _defineProperty(_assertThisInitialized(_this), "setDisplay", function (display) {
      _this.setState({
        display: display
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setProgress", function (loaded, total) {
      _this.setState({
        loaded: loaded,
        total: total
      });
    });

    _defineProperty(_assertThisInitialized(_this), "done", function () {
      _this.setState(_.clone(INITIAL_STATE));
    });

    _defineProperty(_assertThisInitialized(_this), "open", function (args) {
      var callbackFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      _this.setState(_objectSpread({
        global: true,
        opacity: 0.5
      }, args), callbackFn);
    });

    return _this;
  }

  _createClass(Progress, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          display = _this$state.display,
          loaded = _this$state.loaded,
          total = _this$state.total,
          opacity = _this$state.opacity,
          className = _this$state.className,
          style = _this$state.style,
          global = _this$state.global;
      return /*#__PURE__*/React.createElement(ModalDialog, {
        id: "g-progress",
        show: !!display,
        opacity: opacity,
        global: global,
        className: className,
        style: style
      }, display, total && /*#__PURE__*/React.createElement("progress", {
        value: loaded,
        max: total
      }), total && /*#__PURE__*/React.createElement("span", null, Math.floor(loaded / total * 100), "%"));
    }
  }]);

  return Progress;
}(React.Component);

function showProgress(args, shieldOnly) {
  return new Promise(function (resolve, reject) {
    try {
      var open = function open() {
        return globalProgress.open(args, function () {
          return resolve();
        });
      };

      if (globalProgress) {
        open();
      } else {
        (function (progressNode, ProgressDOM) {
          progressNode.id = 'g-progress-container';
          document.querySelectorAll('*[id="g-progress-container"]').forEach(function (el) {
            return el.remove();
          });
          document.body.appendChild(progressNode);
          ReactDom.render( /*#__PURE__*/React.createElement(ProgressDOM, {
            ref: function ref(el) {
              globalProgress = el;
              open();
            }
          }), document.getElementById('g-progress-container'));
        })(document.createElement('DIV'), shieldOnly ? Shield : Progress);
      }
    } catch (e) {
      console.error('show progress error ::: ', e);
      reject(e);
    }
  });
}

export default {
  /**
   * Show blocking display
   * @param {object} cfg - Display config
   * @param {number} [cfg.opacity=0.5] -
   * @param {*} [cfg.className] -
   * @param {boolean} [cfg.global=true] -
   * @param {renderable} cfg.display -
   * @param {object} [cfg.style] -
   *
   * @example
   *
  import {Progress} from 'react-ui'
   Progress.start({
  className:['my-class-name','my-other-class-name'],
  display:<div>In progress...</div>
  })
      */
  start: function start(args) {
    return showProgress(args);
  },

  /**
   * Show blocking progress display
   * @param {renderable} display -
   *
   * @example
   *
  import {Progress} from 'react-ui'
   Progress.startProgress(<div>Start upload...</div>)
      */
  startProgress: function startProgress(display) {
    return showProgress({
      opacity: 0.5,
      className: 'progress-bar',
      display: display
    });
  },

  /**
   * Show blocking spinner
   *
   * @example
   *
  import {Progress} from 'react-ui'
   Progress.startSpin()
      */
  startSpin: function startSpin() {
    return new Promise(function (resolve) {
      var template = document.createElement('div');
      template.innerHTML = ReactDomServer.renderToStaticMarkup( /*#__PURE__*/React.createElement(ModalDialog, {
        show: true,
        id: "g-progress",
        className: "spin",
        opacity: .2,
        contentClassName: "c-center"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fg fg-loading-2 fg-spin"
      })));
      globalProgress = null;
      document.querySelectorAll('*[id="g-progress"]').forEach(function (el) {
        return el.remove();
      });
      document.body.append(template.firstChild);
      resolve();
    }); // return showProgress({
    //   opacity: 0.2,
    //   className: 'spin',
    //   display: <i style={{ fontSize: '1.8em', margin: '10px' }} className="fg fg-loading-2 fg-spin" />
    // });
  },

  /**
   * Show blocking transparent shield
   *
   * @example
   *
  import {Progress} from 'react-ui'
   Progress.startShield()
      */
  startShield: function startShield() {
    return showProgress({
      opacity: 0
    }, true);
  },

  /**
   * Update display text
   *
   * @example
   *
  import {Progress} from 'react-ui'
   Progress.set(<div>5 more minutes...</div>)
      */
  set: function set(display) {
    globalProgress.setDisplay(display);
  },

  /**
   * Update percentage information
   * @param {number} complete - complete count
   * @param {number} total - total count
   *
   * @example
   *
  import {Progress} from 'react-ui'
   Progress.setProgress(1,40) // will display 2.5%
      */
  setProgress: function setProgress(loaded, total) {
    globalProgress.setProgress(loaded, total);
  },

  /**
   * Turn off blocking display
   * @param {number} [delay=0] - turn off after specified time (in milliseconds)
   *
   * @example
   *
  import {Progress} from 'react-ui'
   Progress.done()
  Progress.done(3000)
      */
  done: function done() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    setTimeout(function () {
      if (globalProgress) globalProgress.done();else document.querySelectorAll('*[id="g-progress"]').forEach(function (el) {
        return el.remove();
      });
    }, delay);
  }
};